import { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import Image from 'next/image';
import styles from './HowBodyWorks.module.scss';
import ImageWithTextCard from '../../../../../commons/components/ui/Cards/ImageWithTextCard/ImageWithTextCard';
import { showcaseProducts } from './constants';
import LearnMoreDrawer from '../learnMoreDrawer/LearnMoreDrawer';
import { graph_howItWorks } from '../../../../../src/images';
import imgLoader from '../../../../../imgloader';
const HowBodyWorks = ({ page, id }) => {
  const [showEvents, setShowEvents] = useState(false);
  const [drawerPosition, setDrawerPosition] = useState('right');

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const screenWidth = entry.contentRect.width;
        // Adjust position based on screen width
        if (screenWidth < 600) {
          setDrawerPosition('bottom'); // Adjust position for small screens
        } else {
          setDrawerPosition('right'); // Default position for larger screens
        }
      }
    });

    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const onClicklearnMore = () => {
    setShowEvents(true);
  };

  const AboutProduct = () => {
    return (
      <div className={styles.timelineContentWrapper}>
        <div className={styles.timelineContentContainer}>
          <div>
            <Typography variant="h3" color="primary">
              Start Feeling Relief In the First Week of Taking Relief Factor
            </Typography>
          </div>
          <div className={styles.content}>
            <Typography variant="p1" color="primary">
              Unlike alternatives, Relief Factor attacks pain at the source
              often times eliminating it all together, not just covering it up.
              Relief Factor supports the body’s natural healthy response to
              inflammation and provides relief from aches and pains, commonly
              caused by aging, exercise, and everyday living.
            </Typography>
          </div>
          <div className={styles.content}>
            <Typography variant="p1" color="primary">
              It's 100% drug-free and easy-to-use without unpleasant side
              effects.
            </Typography>
          </div>
          <div className={styles.ImgContainer}>
            <Image
              alt={'Graph how it works'}
              layout="fill"
              src={graph_howItWorks}
              loading="eager"
              objectFit="contain"
              loader={imgLoader}
              className={styles.graphImage}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <LearnMoreDrawer
        showDrawer={showEvents}
        setDrawer={setShowEvents}
        position={drawerPosition}
        content={{
          title: 'Attacking the Source of Your Pain',
          component: <AboutProduct />,
        }}
      />
      <div className={styles.productShowcaseExtender} id={id}>
        <div className={styles.productShowcaseContainer}>
          <Grid container>
            {page !== 'Error' ? (
              <Grid container className={styles.productsPitchContainer}>
                <Grid itemxl={6} lg={12} md={8} sx={{ pb: 1 }}>
                  <div className={styles.reviewTitleContainer}>
                    <div className={styles.reviewTitleBox}>
                      <Typography
                        variant="h2"
                        color="primary"
                        className={styles.reviewTitle}
                      >
                        When You{' '}
                        <Typography
                          variant="h2"
                          component={'span'}
                          className={styles.reviewTitleHash}
                        >
                          Feel the Difference
                        </Typography>
                        , You Know It Works
                      </Typography>
                    </div>
                  </div>
                </Grid>
                <Grid item xl={12} className={styles.learnMoreBtn}>
                  <div className={styles.cardBtn} onClick={onClicklearnMore}>
                    <Typography variant="h5"> + Learn More </Typography>
                  </div>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            <Grid container wrap="nowrap" className={styles.productsContainer}>
              <Grid item xl={4} sx={{ scrollSnapAlign: 'start' }}>
                <ImageWithTextCard
                  {...showcaseProducts.Product1}
                  className={styles.leftPadding}
                />
              </Grid>

              <Grid item xl={4} sx={{ scrollSnapAlign: 'center' }}>
                <ImageWithTextCard {...showcaseProducts.Product2} />
              </Grid>
              <Grid item xl={4} sx={{ scrollSnapAlign: 'center' }}>
                <ImageWithTextCard
                  {...showcaseProducts.Product3}
                  className={styles.rightPadding}
                />
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default HowBodyWorks;
